const initEvents = () => {
    $('.hide-banner').click(function() {
        $(this).next().fadeOut();
        $(this).fadeOut();
    });

    $('.notification-close').click(function() {
        $(this).parent().slideUp();
    });

    $(window).click(function () {
        $('#top-message-bar').fadeOut();
    })
};

export {
    initEvents
};
